import { Box } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import LoaderComponent from 'components/Loader';

const DrawerLoader = () => {
	const theme= useTheme();
	const colors = theme.palette;
	return (
		<Box width={500} height="100vh" sx={{backgroundColor: `${colors.white.main} !important`, display: "flex", alignItems: "center"}}>
			<LoaderComponent />
		</Box>
	);
};

export default DrawerLoader;
